import './crop-stage-wrap.less';

const CropStageWrap: React.FC = ({ children }) => {
    return (
        <div className="l-cropStageWrap" id="crop-stage-wrap">
            {children}
        </div>
    );
};

export default CropStageWrap;
